/** R10-12 — consulta do destaque "Ao vivo" (menu + faixa), compartilhada pelo cache. */
import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { LIVE_SESSIONS_KEY } from '@/features/liveSessions/useLiveSessions'
import { LIVE_NOW_POLL_MS } from './liveNow'

export const LIVE_NOW_KEY = [...LIVE_SESSIONS_KEY, 'live_now'] as const

/**
 * A cada minuto e ao voltar para a aba. `enabled` = o plano libera `aulas_ao_vivo`
 * (sem isso o endpoint responde 403). Erro nao tem retry nem tela: sem dado, sem selo.
 */
export function useLiveNow(enabled: boolean) {
  return useQuery({
    queryKey: LIVE_NOW_KEY,
    queryFn: () => api.liveSessions.liveNow(),
    select: (response) => response.live_now,
    enabled,
    refetchInterval: LIVE_NOW_POLL_MS,
    refetchOnWindowFocus: true,
    staleTime: LIVE_NOW_POLL_MS / 2,
    retry: false,
  })
}
